import { MarketingWorkFile } from "@/bryntum-lib/models/MarketingWorkFile";
import { MarketingWorkFileCard } from "@/bryntum-lib/models/MarketingWorkFileCard";
import { useWorkFileDetail } from "../hooks/useWorkFiles";
import { WorkFileCardList } from "./WorkFileCardList";
import { WorkFileLivePreview } from "./WorkFileLivePreview";

interface WorkFileDetailViewProps {
  file: MarketingWorkFile;
  cards: MarketingWorkFileCard[];
  onBack: () => void;
}

export const WorkFileDetailView = ({ file, cards, onBack }: WorkFileDetailViewProps) => {
  const hubLabel = file.problemHubRecord?.label ?? null;

  const {
    fileCards,
    selectedCardId,
    selectedCard,
    handleSelectCard,
    isAddingCard,
    handleAddCard,
    handleCancelAdd,
    handleSave,
    handleDelete,
  } = useWorkFileDetail(file, cards);

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      {/* Body — padded container matching grid view's p-4 scroll area */}
      <div className="min-h-0 flex-1 overflow-hidden p-4">
        <div className="grid h-full grid-cols-1 gap-4 lg:grid-cols-[300px_1fr]">
          <WorkFileCardList
            cards={fileCards}
            selectedCardId={selectedCardId}
            onSelectCard={handleSelectCard}
            onAddCard={handleAddCard}
            isAddingCard={isAddingCard}
          />
          <WorkFileLivePreview
            card={selectedCard}
            isNewCard={isAddingCard}
            onSave={handleSave}
            onDelete={handleDelete}
            onCancel={handleCancelAdd}
            file={file}
            hubLabel={hubLabel}
            onBack={onBack}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkFileDetailView;
